import { captureException } from '@sentry/vue';

import { log } from '@libs/utils';

import { getErrorMessage } from './errorMessage';

export function logException(
  error: unknown,
  value?: Record<string, unknown>
): void;
export function logException(
  message: string,
  value?: Record<string, unknown>
): void;
export function logException(
  errorOrMessage: unknown,
  value?: Record<string, unknown>
): void {
  log({ title: 'Exception', context: [errorOrMessage, value], level: 'error' });

  if (import.meta.env.MODE !== 'development') {
    // NOTE: Pass real Error objects through to preserve their stack, name, cause, and Sentry grouping; only wrap non-Error values.
    const sentryError =
      errorOrMessage instanceof Error
        ? errorOrMessage
        : new Error(getErrorMessage(errorOrMessage));

    captureException(sentryError, {
      extra: {
        value,
      },
    });
  }
}
